/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Foot_LinkInputs */

const en_st_foot_link = /** @type {(inputs: St_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const id_st_foot_link = /** @type {(inputs: St_Foot_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {St_Foot_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_foot_link = /** @type {((inputs?: St_Foot_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Foot_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_foot_link(inputs)
	return en_st_foot_link(inputs)
});